import repository from '../../repositories/request/request.history.repository';

const findByRequestId = async (requestId) =>
    repository
        .findByRequestId(requestId)
        .then(res => res.data);

export default {
    findByRequestId
}